export const CARET_SIZE = 24;

export const PRODUCT_LINKS = {
  appIntegrations: {
    text: 'App integrations',
    description: 'Explore 5,000+ app connections',
    href: '/apps',
  },
  earlyAccessProgram: {
    text: 'Zapier Early Access',
    href: '/early-access',
  },
  features: {
    text: 'Features',
    description: 'Build flexible workflows',
    href: '/features',
  },
  howItWorks: {
    text: 'How it works',
    description: 'Learn the basics',
    href: '/how-it-works',
  },
  security: {
    text: 'Security',
    description: 'Trusted by 2M+ businesses',
    href: '/security',
  },
  zapierTables: {
    text: 'Zapier Tables',
    href: '/tables',
    icon: 'navTable',
    description: 'No-code databases built for Zaps',
  },
  zapierTransfer: {
    text: 'Zapier Transfer',
    href: '/transfer',
    icon: 'arrowConnect',
    description: 'Move bulk data on demand',
  },
};

export const SIDEBAR_PRODUCT_MENU = {
  text: 'Product',
  href: null,
  submenu: [
    {
      text: PRODUCT_LINKS.howItWorks.text,
      href: PRODUCT_LINKS.howItWorks.href,
    },
    {
      text: PRODUCT_LINKS.security.text,
      href: PRODUCT_LINKS.security.href,
    },
    {
      text: PRODUCT_LINKS.features.text,
      href: PRODUCT_LINKS.features.href,
    },
    {
      text: PRODUCT_LINKS.appIntegrations.text,
      href: PRODUCT_LINKS.appIntegrations.href,
    },
    {
      text: PRODUCT_LINKS.earlyAccessProgram.text,
      href: PRODUCT_LINKS.earlyAccessProgram.href,
      submenu: [
        {
          text: `${PRODUCT_LINKS.zapierTransfer.text} (beta)`,
          href: PRODUCT_LINKS.zapierTransfer.href,
        },
        {
          text: `${PRODUCT_LINKS.zapierTables.text} (beta)`,
          href: PRODUCT_LINKS.zapierTables.href,
        },
      ],
    },
  ],
};
